module.exports = __webpack_public_path__ + "static/media/info-icon.fee8dffe.svg";